export default {
    notFound: 'NOTFOUND',
    notSigned: 'NOTSIGNED',
    ongoingSigning: 'ONGOING_SIGNING',
    partiallySigned: 'PARTIALLYSIGNED',
    signed: 'SIGNED',
    cancelled: 'CANCELLED',
    deleted: 'DELETED',
    expired: 'EXPIRED',
};
